import { installCanvas2DWillReadFrequentlyDefault } from './utils/canvasOptimizer';
import { initPiConsoleBridge } from './utils/piConsoleBridge';
import { isAppDebugEnabled } from './utils/debug/debugEnv';
import '@mdi/font/css/materialdesignicons.css';

installCanvas2DWillReadFrequentlyDefault();
initPiConsoleBridge({
  serverUrl: isAppDebugEnabled() ? 'http://localhost:9877' : null
});

import Vue from 'vue';
import main from './pages/MainPage.vue';

import vuetify from './plugins/vuetify';
import i18n from './plugins/i18n';
import router from './plugins/router';
import store, { storeRehydrated } from './store';
import './assets/css/main.css';
import './apps/EventBus';
import { installAlertOnBridge } from './utils/alertOnBridge';
import initStompService from './utils/websocket/stompService.js';
import { initSentry } from './plugins/sentry.js';
import { initAppAuth, registerAuthHttpInterceptor } from '@/auth';
import {
  appPerfMark,
  appPerfMeasure,
  appPerfSetOrigin,
  appPerfAsync,
  appPerfScheduleFirstPaint,
  registerAppPerfHttpInterceptor,
  appPerfScheduleBootstrapReport
} from '@/utils/appBootstrapPerfLog.js';

appPerfSetOrigin('main.js:module-eval');

Vue.config.productionTip = false;

// Sentry 초기화 (Vue 인스턴스 생성 전에 실행)
initSentry();
registerAuthHttpInterceptor();
registerAppPerfHttpInterceptor();
appPerfScheduleBootstrapReport(20000);

// Console 설정은 vue.config.js의 terser 설정에서 처리

window.store = store;
installAlertOnBridge(Vue.prototype.$eventBus, store);

async function mountApp() {
  appPerfMark('mountApp:start');
  await appPerfAsync('initAppAuth', () => initAppAuth(storeRehydrated));

  appPerfMark('initStompService:start');
  initStompService();
  appPerfMeasure('initStompService', 'initStompService:start');

  appPerfMark('vue:mount:before');
  new Vue({
    store,
    vuetify,
    i18n,
    router,
    beforeCreate() {
      //어떤 페이지에서든 새로고침시 업로드 snackbar 등 업로드 관련 데이터 초기화 필요 (업로드중지되기때문)
      this.$store.dispatch('pairingfile/resetPairing');
      this.$store.dispatch('uploadfile/resetAllUpload');
    },
    render: h => h(main)
  }).$mount('#app');
  appPerfMeasure('vue:rootMount', 'vue:mount:before');
  appPerfMeasure('mountApp', 'mountApp:start');
  appPerfScheduleFirstPaint('root-vue', { path: window.location.pathname });
}

mountApp().catch((error) => {
  console.error('[main] failed to initialize auth session:', error);
});
